document.addEventListener('DOMContentLoaded', function load() {

    $(document).on("click", "#open-pw-cards", function () {
        addCustomProduct(false); 
    });
  
    function replaceCartDrawerImgs() {
        var textArray = $("form#CartDrawer .f-cart-drawer__item .f-cart-drawer__product-info:contains('PersonalisationID')");
        textArray.each(function () {

            var cardID = this.innerText.match(/PersonalisationID:.*/);
            cardID = cardID[0];
            cardID = cardID.replace("PersonalisationID:", "").trim();
            cardID = cardID.match(/[^\s]+/);
            cardID = cardID[0];
            var rand = Math.floor(Math.random() * 10000);
            var newSrc = "https://pwcdn.net/thumbnails/1134/" + cardID + ".jpg?r=" + rand;
            $(this).parent().find("img").addClass("pwThumbImage");
            $(this).parent().find("img").attr("src", newSrc);
            $(this).parent().find("img").attr("srcset", newSrc);
        });
    }
  
    $(document).on("click", ".f-cart-drawer__remove", function () {
        setTimeout(function () {
            replaceCartDrawerImgs();
        }, 1000);

    });

    replaceCartDrawerImgs();

    if ($("body").hasClass("template-product") || $("body").hasClass("template-index")) {

        //$(".product-form__add-button").attr("disabled", true);

        $(document).on("click", "#no-modal", function () {
         // $(".product-form__add-button").attr("disabled", false);
          $(".printzware-custom-section").remove();
          $(".pwAddToCart").removeClass("customAddToCart");
          
          $(".printzware-custom-section img").attr("src", "https://cdn.shopify.com/s/files/1/0708/4412/1361/files/birthday-card.jpg?v=1720397949");
        });
        $(document).on("click", "#yes-modal,#personalised", function () {
          // $(".product-form__add-button").attr("disabled", true);
          $(".printzware-custom-section img").attr("src", "https://cdn.shopify.com/s/files/1/0708/4412/1361/files/birthday-card.jpg?v=1720397949");
          //$(".printzware-custom-section img").css("width", "100%");
          $("#yes-modal").html("Personalise");
          $("#yes-modal").removeClass("make-center");            
          $("#no-modal, .printzware-custom-section p").show();
          $(".pwAddToCart").addClass("customAddToCart");
          addCustomProduct(true);
        });
        

        // called when user returns from Printzware Modal Window
        function closeDialog() {
            document.ontouchmove = function (e) {
                return true;
            }
            var offset = parseInt($j("body").css('top'), 10);
            var scrollingElement = document.scrollingElement || document.documentElement;
            $j("body").removeClass("modal-open pw-modal-open");
            $j("body").css({'padding-right': '0px'});
            if (typeof pw_disable_scrolltop === 'undefined') {
                $j(window).scrollTop(offset * -1);
            }
            // apply the original viewport
            viewport = document.querySelector("meta[name=viewport]");
            //viewport.setAttribute('content', origViewportString);
            // set iframe to blank page and close
            $j('#pw_iframe').attr('src', 'about:blank');
            $j('#pw_modal').modal('hide');
            $j('#pw_modal').removeClass('in');
            $j('#pw_modal').hide();
            $j('.bootstrap-wrapper .modal-backdrop').remove();
        }


        $(document).on("click", "#pw_modal #pwCancelButton, .bootstrap-wrapper, #pw_modal, .modal-backdrop", function (e) {
          closeDialog();
          $("body").css("top", 0)
        });

/*
        $(document).on("click", "#cardspopup", function () {

            $("#pw_modal").modal("hide");

        });*/


        function addCustomProduct(addToCart) {
            
            $("#personalised").attr("checked", true);
            $("#cardzware-popup").modal("hide");
            $("#pw_modal").addClass("greeting_cards_modal");
            
            $("#pw_greeting_card_order").val("");
            $("#pw_greeting_card_product_id").val("");
            if ($(".pw-greeting-card-preview").length) {
                $(".pw-greeting-card-preview").remove();
            }

            var shopifyCardVariantID;
            data = {"func": "shopifyGetClientData"};
            var modalCardURL, confirmURL;
            $.ajax({
                type: 'POST',
                url: window.location.origin + "/a/greeting-cards/index.php",
                data: data,
                crossDomain: true,
                dataType: 'json',
                success: function (json_data, textStatus, jqXHR) {
                    confirmURL = json_data.confirmURL;
                    modalCardURL = urldecode(json_data.modalURL);
                    shopifyCardVariantID = json_data.cardVariantID;
                    pwProductMode = false;
                  
                  opendialog(modalCardURL);
                  // $("#pw_iframe").prop('src', modalCardURL);
                    var urlParams = new URLSearchParams(modalCardURL);
                    var orderID = urlParams.get('o');


                },
                error: function (json_data, textStatus, errorThrown) {
                    console.log('pw: ERROR get clientID failed, card images will not be changed');
                }
            });

            //returnData = JSON.parse('{"' + decodeURI(e.data).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}')
            $j.receiveMessage(function (e) {
               returnData = JSON.parse('{"' + decodeURI(e.data).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}')
                //returnData = JSON.parse('{"' + decodeURI(e.data).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}')
              
                if (returnData.func == "addCard") {

                   
                    setTimeout(function () {

                        var orderID = returnData.yourOrderID;
                        var shopifyCardVariantID = 49092479516945;

                        $("#pw_greeting_card_order").val(orderID);
                        $("#pw_greeting_card_product_id").val(shopifyCardVariantID);

                        var orderID = returnData.yourOrderID;
                        closeDialog();
                        $(".printzware-custom-section img").attr("src", "https://pwcdn.net/thumbnails/1834/"+orderID+".jpg");
                        $(".printzware-custom-section img").css("width", "150px");
                        $("#yes-modal").addClass("make-center");
                        $("#yes-modal").html("Edit");
                        $("#no-modal, .printzware-custom-section p").hide();
                       //$(".product-form__add-button").attr("disabled", false);
                        var quantity = 1;
                        var productVariantID = $('.pwProductSelect:checked').val();

                      
                    $(document).on("click", ".pwAddToCart.customAddToCart", function (e) {
            
                        e.preventDefault();
                        var pwOrderID = $("#pw_greeting_card_order").val();
            
                        //if (pwOrderID && pwOrderID != null) {
            
                            var orderID = $("#pw_greeting_card_order").val();
                            var shopifyCardVariantID = $("#pw_greeting_card_product_id").val();
                          
                            var quantity = $("#qtyValue").val();
                            var productVariantID = $('.pwProductSelect:checked').val();
                            if(productVariantID == undefined){
                               var productVariantID = $('.pwProductSelectSingle').val();
                            }
                            var personalisedMessage = $("#personalisedMessage").val();
                            var Number = $('[name^="properties[Number]"]').val();
                            var alphabets = $('[name^="properties[alphabets]"]').val();
                            var items = [
                                {
                                    id: shopifyCardVariantID,
                                    properties: {
                                        'PersonalisationID': orderID
                                    },
                                    quantity: 1
                                },
                                {
                                    quantity: quantity,
                                    properties: {
                                        'personalisedMessage': personalisedMessage,
                                         'Number': Number,
                                         'alphabets': alphabets,
                                    },
                                    id: productVariantID,
                                }
                            ];
                            fetch('/cart/add.js', {
                                method: "post",
                                headers: {'content-type': 'application/json'},
                                body: JSON.stringify({
                                    items: items
                                })
                            })
                            setTimeout(function () {
                                var confirmURL = "/cart";
                                window.location.replace(confirmURL);
                            }, 1000);
                       /* } else {
            
                            $("#cardzware-popup").modal("show");
                        }*/
            
            
                    });

                        data = {"func": "shopifySaveThumb", "yourOrderID": orderID};
                       
                       /* $j.ajax({
                            type: 'POST',
                            url: window.location.origin + "/a/greeting-cards/index.php",
                            data: data,
                            crossDomain: true,
                            dataType: 'json',
                            success: function (json_data, textStatus, jqXHR) {
                                console.log("pw: cart updated(" + orderID + "), thumb saved. reload cart");
                                if (confirmURL != "") {
                                    window.location.href = confirmURL;
                                } else {
                                    location.reload();
                                }
                            },
                            error: function (json_data, textStatus, errorThrown) {

                                console.log('pw: thumb save failed');
                            }
                        });*/

                        $("#pw_modal").modal("hide");
                       /* if (addToCart == true) {
                            setTimeout(function () {
                                var confirmURL = "/cart";
                                window.location.replace(confirmURL);
                            }, 1000);

                        }*/

                    }, 1000);

                } else if (returnData.func == "cancel") {
                    $("#pw_modal").modal("hide");
                    closeDialog();
                }
            });

        }


        /*var pwPersonalisation = true;
        var confirmURL = "/cart";
        setTimeout(function () {
            $('.pwAddToCart').removeAttr("disabled");
            $('.pwAddToCart').before('<div class="pw-greeting-card-special" style="display:none;"><input type="hidden" id="pw_greeting_card_order"><input type="hidden" id="pw_greeting_card_product_id"></div>');
            var quantity = $(".f-quantity__input").val(); //quantity input value, selector depends on the theme
            var productVariantID = $('.pwProductSelect').val();*/
            if ($("body").hasClass("template-product")) {
                

              
            }

            var waitForEl = function (selector, callback) {
                if (jQuery(selector).length) {
                    callback();
                } else {
                    setTimeout(function () {
                        waitForEl(selector, callback);
                    }, 100);
                }
            };
        //}, 4000);

        function urldecode(str) {
            return decodeURIComponent((str + '').replace(/%(?![\da-f]{2})/gi, function () {
                // PHP tolerates poorly formed escape sequences
                return '%25'
            }).replace(/\+/g, '%20'))
        }

    }
}, false);

